export const dirtyTicketIdsSelector = state =>
  state.tickets.dirtyTicketIds || {}
